import { render, staticRenderFns } from "./WarehouseManage.vue?vue&type=template&id=6160bb9a&scoped=true&"
import script from "./WarehouseManage.vue?vue&type=script&lang=js&"
export * from "./WarehouseManage.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseManage.vue?vue&type=style&index=0&id=6160bb9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160bb9a",
  null
  
)

export default component.exports